// extracted by mini-css-extract-plugin
module.exports = {"container":"TemplateAuth_container__3A3WI","logo":"TemplateAuth_logo__1gKG1","textTitle":"TemplateAuth_textTitle__1om5k","rotate":"TemplateAuth_rotate__3NkZG"};